export const INITIAL_ENTRY = 'initial entry';
export const EDITED = 'edited';

export default Object.freeze({
    INITIAL_ENTRY,
    EDITED
});